import Button from "../Button";
import JalaliDateRangePicker from "./JalaliDateRangePicker";

interface ChartDateRangeFilterProps {
  fromDate: string;
  untilDate: string;
  onRangeChange: (fromDate: string, untilDate: string) => void;
  onApply: () => void;
  loading?: boolean;
  disabled?: boolean;
  applyLabel?: string;
}

export default function ChartDateRangeFilter({
  fromDate,
  untilDate,
  onRangeChange,
  onApply,
  loading = false,
  disabled = false,
  applyLabel = "اعمال فیلتر",
}: ChartDateRangeFilterProps) {
  const canApply = Boolean(fromDate && untilDate);

  return (
    <div className="flex flex-wrap items-end gap-3">
      <JalaliDateRangePicker
        label="بازه زمانی"
        fromDate={fromDate}
        untilDate={untilDate}
        onChange={onRangeChange}
        disabled={disabled || loading}
      />
      <Button
        variant="primary"
        style="solid"
        size="md"
        text={applyLabel}
        loading={loading}
        disabled={disabled || !canApply}
        onClick={onApply}
        customClassName="min-w-[120px]"
      />
    </div>
  );
}
